// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__HRZD8","loader":"Loader_loader__TI7eX","l13":"Loader_l13__H61DW"};